import pino from 'pino'
import { serializeError } from 'serialize-error'

/**
 * Error serialization, shared by every logger. Split out from the full default config
 * because `baseLogger` needs this and only this - a raw Error reaches JSON.stringify as
 * `{}`, so without it `withError` detail is silently dropped.
 */
export const LOGLAYER_ERROR_SERIALIZER = {
    errorSerializer: serializeError,
}

export const LOGLAYER_DEFAULT_CONFIG = {
    ...LOGLAYER_ERROR_SERIALIZER,
    metadataFieldName: 'metadata',
    contextFieldName: 'context',
}

/**
 * Shared Pino configuration for consistent log formatting across all loggers.
 * Use with pino({ ...PINO_DEFAULT_CONFIG, name: 'your-logger', level: config.logLevel })
 */
export const PINO_DEFAULT_CONFIG: pino.LoggerOptions = {
    base: undefined, // turns off pid and hostname
    formatters: {
        level: (label) => ({ level: label.toUpperCase() }),
    },
    timestamp: pino.stdTimeFunctions.isoTime,
}
